
      if (new URLSearchParams(window.location.search).get("debug") === "1") {
        import("./type-lab.js");
      }
    